export default {
  gutters: {
    paddingLeft: 24,
    paddingRight: 24,
  },
};
